module.exports = __webpack_public_path__ + "static/Uitgeverij-e3119230e620f528bc89332c2359b4ee.png";